import type { SerializedHashTable } from '@src/scenario-editor/utils/serializer';
import type { ValidationResultItem } from '@src/atoms';

export type CallbackFn = (payload: SerializedHashTable, validationResult: ValidationResultItem[]) => void;

/**
 * Hands the serialized canvas to the host app, unless it is empty.
 *
 * A real scenario always has at least its start and finish nodes, so an empty
 * structure only means the canvas has not been filled from `defaultValue` yet.
 * Validators can finish warming up before that happens (fast backend), and
 * forwarding the empty canvas made the host replace the scenario with nothing:
 * the editor remounted empty and crashed, or could be saved empty (LF360-2031).
 */
export const notifyConsumer = (
  payload: SerializedHashTable,
  validationResults: ValidationResultItem[],
  callback?: CallbackFn,
) => {
  if (!Object.keys(payload ?? {}).length) {
    return;
  }

  if (callback && typeof callback === 'function') {
    callback(payload, validationResults);
  }
};
